<template>
  <div class="store-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <div>
          <el-form-item label="姓名：" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" class="phone" prop="userPhone">
            <el-input v-model="form.userPhone" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="visible = true">添加</el-button>
          <el-button type="primary" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="userPhone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="shopName" label="购买店铺" align="center"></el-table-column>
        <el-table-column label="小票" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.ticketUrl"
              fit="cover"
              :preview-src-list="previewList"
              @click="handlePreviewSingle(scope.row.ticketUrl)"
              style="height:100px;"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.ticketState === 1">未审核</span>
            <span v-else-if="scope.row.ticketState === 2">已通过</span>
            <span v-else>拒绝</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span
              class="order"
              @click="handleOrder(scope.row.id)"
              v-if="scope.row.ticketState === 1"
            >订单生成</span>
            <span
              class="refuse"
              v-if="scope.row.ticketState === 1"
              @click="handleRefuse(scope.row.id)"
            >拒绝</span>
            <span v-if="scope.row.ticketState !== 1">暂无</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <addCardTicket
      :visible="visible"
      :loading="ticketLoading"
      @close="visible = false"
      @confirm="handleConfirm"
    />
    <el-dialog title="拒绝原因" :visible.sync="dialogVisible">
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 6}"
        placeholder="请简要填写拒绝原因"
        v-model="dislogData.refuseInfo"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="refuseLoading"
          @click="handleRefuseReason"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getSmallTicketList,
  refuseSmallTicket,
  addSmallTicket,
} from '@/api/audit';
import Pagination from '@/components/Pagination';
import addCardTicket from './components/addCardTicket.vue';

export default {
  data() {
    return {
      previewList: [],
      dislogData: {
        id: '',
        refuseInfo: '',
      },
      form: {
        userName: '',
        userPhone: '',
      },
      tableData: [],
      visible: false,
      ticketLoading: false,
      refuseLoading: false,
      dialogVisible: false,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Pagination,
    addCardTicket,
  },
  mounted() {
    this.getSmallTicketList();
  },
  methods: {
    getSmallTicketList() {
      this.loading = true;
      getSmallTicketList({
        userName: this.form.userName,
        userPhone: this.form.userPhone,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    handleConfirm(form) {
      this.ticketLoading = true;
      addSmallTicket(form).then((res) => {
        if (res.success) {
          this.$message.success('小票信息添加成功');
          this.ticketLoading = false;
          this.visible = false;
          this.getSmallTicketList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    refuseSmallTicket() {
      this.refuseLoading = true;
      refuseSmallTicket(this.dislogData).then((res) => {
        if (res.success) {
          this.refuseLoading = false;
          this.dialogVisible = false;
          this.getSmallTicketList();
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getSmallTicketList();
    },
    handlePreviewSingle(url) {
      this.previewList = [url];
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getSmallTicketList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getSmallTicketList();
    },
    handleOrder(id) {
      this.$router.push({
        name: 'AuditOrder',
        query: {
          id,
        },
      });
    },
    // 拒绝弹框显示
    handleRefuse(id) {
      this.dialogVisible = true;
      this.dislogData.id = id;
    },
    // 拒绝
    handleRefuseReason() {
      const { refuseInfo } = this.dislogData;
      if (!refuseInfo) {
        this.$message.warning('请输入拒绝原因');
      } else {
        this.refuseSmallTicket();
      }
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getSmallTicketList();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.order, .refuse
  color #1890ff
  cursor pointer
.order, .refuse
  margin-right 20px
.storeImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
.phone
  margin-left 30px
>>>textarea
  min-height 90px !important
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
